import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { aiStudioService } from '../../../service/aiStudio'

export interface UseFreeSynthesisStatusParams {
  id: number | null
  enabled?: boolean
}

export const useFreeSynthesisStatus = ({
  id,
  enabled = true,
}: UseFreeSynthesisStatusParams) => {
  const queryClient = useQueryClient()

  const query = useQuery({
    queryKey: ['ai-studio', 'free-synthesis-status', id],
    queryFn: async () => {
      if (!id) throw new Error('ID is required')
      return await aiStudioService.getFreeSynthesisStatus(id)
    },
    enabled: enabled && !!id,
    refetchInterval: (query) => {
      // pending 또는 processing 상태일 때만 5초마다 폴링
      const data = query.state.data
      if (data?.status === 'pending' || data?.status === 'processing') {
        return 5000
      }
      return false
    },
    staleTime: 0, // 항상 fresh하지 않은 것으로 처리하여 폴링 활성화
  })

  // 완료되면 목록을 새로고침 (onSuccess 대체)
  useEffect(() => {
    if (query.data && (query.data.status === 'completed' || query.data.status === 'failed')) {
      queryClient.invalidateQueries({
        queryKey: ['ai-studio', 'free-synthesis']
      })
    }
  }, [query.data, queryClient])

  return query
}